import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Author extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listItem: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: 'Income Tax advisory services',
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    title: 'GST advisory service',
                },
                {
                    id: 3,
                    icon: 'fa fa-check',
                    title: 'Helping clients achieve maximum savings',
                },
            ]
        }
    }
    render() {
        return (
            <section className="author-section section-padding dark-bg-light" id="author">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="section-heading center-heading text-center mb-60">
                                <h3 className="heading-title">About the author</h3>
                                {/* <p>A Chartered Accountant, specializes in Income Tax and GST advisory services.</p> */}
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-5 col-md-6">
                            <div className="auhtor-img mb-4 mb-lg-0">
                                <img src="assets/images/bg/author.png" alt="" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-6 ps-4">
                            <div className="section-heading mb-0">
                                <h3 className="heading-title" style={{ backgroundColor: "white", color: "black", textAlign: "center", borderRadius: 50, padding: "8px 0", marginBottom: 25 }}>CA Rahul P Patil</h3>
                                <p className="lead">CA Rahul P Patil is a Chartered Accountant with a deep interest in simplifying tax laws and enhancing financial literacy. With years of experience in taxation and compliance, he has contributed extensively to the field through his research and professional insights.</p>
                                <p>As an advocate for informed financial decision-making, he has authored this e-book to provide a structured approach to tax planning for salaried individuals. This book presents an educational perspective on tax-saving provisions and best practices to help individuals navigate the complexities of taxation effectively.</p>
                                <p>Through this publication, CA Rahul aims to empower readers with a better understanding of tax regulations, ensuring they can make well-informed financial choices while staying fully compliant with the law.</p>
                            </div>

                            <div className="author-desc">
                                <ul className="list-unstyled">
                                    {
                                        this.state.listItem.map((data, i) => (
                                            <li key={i}><i className={data.icon}></i> {data.title}</li>
                                        ))
                                    }
                                </ul>
                                {/* <p>Reach Me on <Link to="#">Twiiter</Link> or <Link to="#">Facebook</Link> or <Link to="#">Linkedin</Link></p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Author;
